import { render, staticRenderFns } from "./StreamerSettings.vue?vue&type=template&id=b2bca078&"
import script from "./StreamerSettings.vue?vue&type=script&lang=js&"
export * from "./StreamerSettings.vue?vue&type=script&lang=js&"
import style0 from "./StreamerSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports